export function getCsrfToken (): string {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ''
}

interface FetchJsonOptions extends Omit<RequestInit, 'body'> {
  body?: unknown
}

export async function fetchJson (url: string, options: FetchJsonOptions = {}): Promise<Response> {
  const { body, headers, ...rest } = options
  return await fetch(url, {
    ...rest,
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
      ...headers
    },
    body: body !== undefined ? JSON.stringify(body) : undefined
  })
}
